"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  GET_REPORT_DEFAULT: "@@cp-report/get-report-default",
  ADD_REPORT_DEFAULT: "@@cp-report/add-report-default",
  ADD_UPDATE_REPORT_DEFAULT_CP: "@@cp-report/add-update-report-cp",
  GET_REPORT_BY_ID: "@@cp-report/get-report-by-id",
  UPDATE_GREETING: "@@cp-report/update-greeting",
  UPDATE_HEADER_IMAGE: "@@cp-report/update-header-image",
  UPDATE_PANEL_SEQUENCE: "@@cp-report/update-panel-sequence",
  GET_HEADER_IMAGE: "@@cp-report/get-header-image",
  GET_BUILDER_REPORT_BY_ID: "@@cp-report/builder-report-by-id",
  GET_ASSET_FOLDER_LIST: "@@cp-report/asset-folders",
  PANEL_LIST: "@@cp-report/get-panel-list",
  GET_GREETING: "@@cp-report/get-greeting",
  DELETE_PANEL: "@@cp-report/delete-greeting",
  UPDATE_PANEL: "@@cp-report/update-panel",
  GET_HEADER_IMAGE_LIST: "@@cp-report/get-header-image-list",
  SUCCESS: "@@cp-report/success",
  ERROR: "@@cp-report/error",
  RESET: "@@cp-report/reset"
};
exports.actionTypes = actionTypes;